import { Component, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgIf } from "@angular/common";

import { SavedSearchModel } from "../../saved-search.model";
import { SavedSearchesService } from "../../saved-searches.service";

@Component({
    selector: "pcg-ng-saved-search-card",
    templateUrl: "saved-search-card.component.html",
    imports: [
        NgIf,
        FormsModule
    ],
    standalone: true
})
export class SavedSearchCardComponent {
    public editing = false;
    @Input() public savedSearch: SavedSearchModel;
    public formModel: SavedSearchModel;

    public constructor(
        private savedSearchesService: SavedSearchesService
    ) {
    }

    public startEditing(): void {
        this.editing = true;
        this.formModel = this.savedSearch;
    }

    public endEditing(): void {
        this.editing = false;
    }

    public save(): void {
        this.savedSearchesService.update(this.formModel);
        this.editing = false;
    }

    public delete(): void {
        this.savedSearchesService.delete(this.formModel);
    }

    public cancel(): void {
        this.editing = false;
    }
}
